import ListingCardInline from './ListingCardInline';

export default ListingCardInline;
